var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "call",
    d: "M185.625-770a52.444,52.444,0,0,1-23.576-5.833A80.049,80.049,0,0,1,141-791a80.049,80.049,0,0,1-15.167-21.049A52.444,52.444,0,0,1,120-835.625a4.24,4.24,0,0,1,1.25-3.125,4.24,4.24,0,0,1,3.125-1.25h13.611a3.461,3.461,0,0,1,2.363.924,4.248,4.248,0,0,1,1.331,2.479l2.625,12.25a6.992,6.992,0,0,1-.049,2.479,3.746,3.746,0,0,1-1.021,1.9l-9.722,9.819a80.717,80.717,0,0,0,12.2,15.75,67.432,67.432,0,0,0,15.313,11.375l9.236-9.528a5.376,5.376,0,0,1,2.236-1.507,4.494,4.494,0,0,1,2.528-.146l11.569,2.528a4.3,4.3,0,0,1,2.446,1.477,4.092,4.092,0,0,1,.957,2.7v13.125a4.24,4.24,0,0,1-1.25,3.125A4.24,4.24,0,0,1,185.625-770ZM130.6-815.5l7.875-7.972-2.236-10.694h-10.4A33.465,33.465,0,0,0,127-825.854,78.364,78.364,0,0,0,130.6-815.5Zm35.875,35.292a48.523,48.523,0,0,0,8.653,3.014,45.632,45.632,0,0,0,9.042,1.361v-10.4l-10.014-2.042ZM130.6-815.5ZM166.472-780.208Z",
    transform: "translate(-120 840)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.f205d6ed7a934ec8b832c0445e2fddb1.svg";
export { ForwardRef as ReactComponent };